import { render, staticRenderFns } from "./tabValuation.vue?vue&type=template&id=09c0362a&scoped=true"
import script from "./tabValuation.vue?vue&type=script&lang=js"
export * from "./tabValuation.vue?vue&type=script&lang=js"
import style0 from "./tabValuation.vue?vue&type=style&index=0&id=09c0362a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c0362a",
  null
  
)

export default component.exports